import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'app-complaint-detail',
  templateUrl: './complaint-detail.component.html',
  styleUrls: ['./complaint-detail.component.scss']
})
export class ComplaintDetailComponent implements OnInit {

  constructor(
    @Inject(MAT_DIALOG_DATA)
    public data,
    public dialogRef: MatDialogRef<ComplaintDetailComponent>,
  ) { }

  ngOnInit(): void {
  }

  ngAfterViewInit(){
    if(document.getElementById('principal-container')?.parentElement?.parentElement){
      document.getElementById('principal-container').parentElement.parentElement.style.padding = '0px';
    }
  }

}
